import React, { Fragment } from 'react';
import { MdClose } from 'react-icons/md';
import Modal from '../Antd/Modal/Modal';
import Result from '../Antd/Result/Result';
import successIcon from 'assets/images/success-icon.svg';

/*
 * ResultDialog
 *
 * @param {string}   className
 * @param {boolean}  visible
 * @param {boolean}  [closable=true]
 * @param {Function} [onCancel=()=>{}]
 * @param {Node}     [footer=null]
 * @param {string}   [status='success']
 * @param {string}   [title]
 * @param {Node}     [icon]        Node
 * @param {string}   [subtitle]
 * @param {Node}     [actions]     Node or Array of nodes
 * @param {Node}     [zIndex=10001]
 */

// To provide custom styles use specific className and add/override styles in Global.style.js

export default function ResultDialog({
  className,
  visible,
  closable,
  onCancel = () => {},
  footer = null,
  status = 'success',
  title,
  icon,
  subtitle,
  actions,
  children,
  zIndex = 10001
}) {
  return (
    <Fragment>
      <Modal
        zIndex={zIndex}
        className={className}
        visible={visible}
        bodyStyle={{ padding: footer ? '18px 0 0' : '18px 0' }}
        closeIcon={<MdClose size={24} />}
        centered={true}
        width={792}
        footer={footer}
        closable={closable}
        onCancel={onCancel}
        wrapClassName='result-modal'
      >
        <Result
          status={status}
          icon={
            icon ? (
              icon
            ) : (status === 'success' && (
              <Fragment>
                <img alt={'Success check'} src={successIcon} />
              </Fragment>
            ))
          }
          title={title}
          subTitle={subtitle}
          extra={actions}
        >
          {children}
        </Result>
      </Modal>
    </Fragment>
  );
}
